import { cn } from "./utils";

export function GitRefspec({ refspec, current = false }: { refspec: string; current?: boolean }) {
	const currentClasses = [
		"bg-palette-brand-4",
		"text-palette-brand-11",
		"group-data-[active=true]:bg-palette-brand-4",
		"group-data-[state=active]:bg-palette-brand-4",
		"group-data-[active=true]:text-palette-brand-11",
		"group-data-[state=active]:text-palette-brand-11",
	];

	const defaultClasses = [
		"bg-palette-brand-4",
		"text-palette-brand-11",
		"group-data-[active=true]:bg-palette-brand-4",
		"group-data-[state=active]:bg-palette-brand-4",
		"group-data-[active=true]:text-palette-brand-11",
		"group-data-[state=active]:text-palette-brand-11",
	];

	return (
		<code
			className={cn(
				current ? currentClasses : defaultClasses,
				"font-medium",
				"py-0.5",
				"px-1.5",
				"rounded",
				"text-xs"
			)}
		>
			{refspec}
		</code>
	);
}
